export default __webpack_public_path__ + "static/media/envolope.c8ac61a5.svg";